import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  // Subject que emite el estado del menú (true = colapsado, false = expandido)
  private menuToggleSource = new Subject<boolean>();

  // Observable al que los componentes pueden suscribirse
  menuToggle = this.menuToggleSource.asObservable();

  /**
   * Emite el estado actual del menú.
   * @param estado true si el menú está colapsado, false si está expandido
   */
  emitirToggleMenu(estado: boolean) {
    this.menuToggleSource.next(estado);
  }
}
